import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { isUpsellExclusionActive } from '@shared/helpers/function.helpers';
import { Offer } from '@dgx-pr-spa/shared/util';
import { CurrentItem } from '@dgx-pr-spa/shared/util';
import {
  Component,
  EventEmitter,
  Output,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ToggleState } from '@dgx-pr-spa/shared/util';

export enum CurrentItemText {
  open = 'Less detail about your current product',
  closed = 'More details about your current product',
}

@Component({
  selector: 'app-current-item',
  templateUrl: './current-item.component.html',
  styleUrls: ['./current-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentItemComponent {
  constructor(public readonly buildConfigService: BuildConfigService) {}

  /**
   * Emits toggled event when accordion is clicked
   */
  @Output() toggled: EventEmitter<ToggleState> = new EventEmitter();

  /**
   * Receives current item data
   */
  @Input() currentItem = {} as CurrentItem;

  /**
   * Receives offer data
   */
  @Input() offer = {} as Offer;

  /**
   * Accordion header text
   */
  text = CurrentItemText.closed;

  /**
   * Triggered when accordion is toggled
   */
  toggleClick(e: ToggleState) {
    this.text =
      e === ToggleState.open ? CurrentItemText.open : CurrentItemText.closed;
    this.toggled.emit(e);
  }

  isMultiplan() {
    return isUpsellExclusionActive(this.offer);
  }
}
